import React from "react";
import { LinkAreaViewModel } from "../../../Model/Blocks/NotAvailableForEdit/LinkAreaViewModel.csharp";
import { LinkDto } from "../../../Api/Model/LinkDto.csharp";
import { LinkArea } from "./LinkArea";

export const NavigationDropdown: React.FC<{
  linkSections: LinkAreaViewModel[];
  additionalLink: LinkDto;
}> = ({ linkSections, additionalLink }) => {
  return (
    <div className="container-fluid container-xxl">
      <ul className="link-list link-list--bare-bones row mb-0">
        {linkSections.map((section, index) => (
          <li className="col-lg-4 col-xl-3 mb-3" key={index}>
            <LinkArea {...section} />
          </li>
        ))}

        {additionalLink.title && (
          <li className="col-lg-4 col-xl-3 mb-3">
            <a className="link-list-section-heading-link" href={additionalLink.url}>{additionalLink.title}</a>
          </li>
        )}
      </ul>
    </div>
  );
};
